import {
  FooterBoardBox,
  FooterBoardButton,
  FooterBoardContainer
} from "./footerBoard.styled";
import {MenuItem, OutlinedInput, Select} from "@mui/material";
import {Dispatch, useState} from "react";
import {GradientBorderWrapper} from "../ui/includes/GradientInput/gradientInput.styled";
import {UiBoardButtonUp} from "../ui/BoardButtonUp";
import {UiAddButton} from "../ui/addButton";

const pagesOption = ['25', '50', '100', '150']

interface FooterBoardProps {
  pushLimit: string
  setPushLimit: Dispatch<React.SetStateAction<string>>
  handleLoadMore: () => void
  uploadFile: () => void
}

export function FooterBoard({pushLimit, setPushLimit, handleLoadMore, uploadFile}: FooterBoardProps) {
  const [focused, setFocused] = useState(false);
  const [hovered, setHovered] = useState(false);

  const selectHandler = (e: { target: { value: string } }) => {

    setPushLimit(e.target.value);

    setTimeout(() => {
      setFocused(false);
      setHovered(false);
    }, 100);
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <FooterBoardContainer>
      <UiAddButton aboutFunction={uploadFile} />
      <FooterBoardBox>
        <FooterBoardButton variant={'outlined'} onClick={handleLoadMore}>Load more files</FooterBoardButton>
        <GradientBorderWrapper focused={focused} hovered={hovered} maxWidth={'max-content'}>
          <Select
            value={pushLimit}
            onChange={(e) => {selectHandler(e)}}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            input={
              <OutlinedInput
                notched={false}
                sx={{
                  minWidth: '85px',
                  height: '48px',
                  borderRadius: '16px',
                  backgroundColor: '#fff',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                }}
              />
            }
            MenuProps={{
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              disablePortal: true,
            }}
          >
            {pagesOption.map((page, index) => (
              <MenuItem value={page} key={index}>{page}</MenuItem>
            ))}
          </Select>
        </GradientBorderWrapper>
      </FooterBoardBox>
      <UiBoardButtonUp  aboutFunction={() => scrollToTop()}/>
    </FooterBoardContainer>
  );
}
